export default __webpack_public_path__ + "static/tools-d02e4710cd758a1ee30c1e61d146a50e.png";